import { ExamSession, ExamTicket } from "@/components/Types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ExamState {
    examId: string | null;
    examTicket: ExamTicket | null;
    examStage: string | null;
    examSession: ExamSession | null;    
    showCurrentTicket: boolean;
    isSwitchingStages: boolean;
}

const initialState: ExamState = {
    examId: null,
    examTicket: null,
    examStage: null,
    examSession: null,
    showCurrentTicket: false,
    isSwitchingStages: false,
}

export const examSlice = createSlice({
    name: 'exam',
    initialState,
    reducers: {
        setExamId: (state, action: PayloadAction<string>) => {
            state.examId = action.payload;
        },
        setExamTicket: (state, action: PayloadAction<ExamTicket>) => {
            state.examTicket = action.payload;
        },
        setExamStage: (state, action: PayloadAction<string>) => {
            state.examStage = action.payload;
        },
        setExamSession: (state, action: PayloadAction<ExamSession | null>) => {
            state.examSession = action.payload;
        },
        setShowCurrentTicket: (state, action: PayloadAction<boolean>) => {
            state.showCurrentTicket = action.payload;
        },
        resetExamState: (state) => {
            state.examId = null;
            state.examTicket = null;
            state.examStage = null;
            state.examSession = null;
            state.showCurrentTicket = false;            
        },
        setIsSwitchingStages: (state, action: PayloadAction<boolean>) => {
            state.isSwitchingStages = action.payload;
        }
    }
});

export const { setExamId, setExamTicket, setExamStage, setExamSession, setShowCurrentTicket, resetExamState, setIsSwitchingStages } = examSlice.actions;
export default examSlice.reducer;